import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=131a14ba&scoped=true"
import script from "./BillInfo.vue?vue&type=script&lang=js"
export * from "./BillInfo.vue?vue&type=script&lang=js"
import style0 from "./BillInfo.vue?vue&type=style&index=0&id=131a14ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a14ba",
  null
  
)

export default component.exports